@if (displayTooltip) {
  <div #triggerButton data-cy="tooltip-hoverable">
    <svg-icon
      [ngClass]="{
        'question-mark-icon': !whiteStyling,
        'question-mark-icon--white': whiteStyling
      }"
      src="assets/icons/question-mark.svg"
      [svgStyle]="{ 'width.px':22 }"
    ></svg-icon>
  </div>
  <div #popoverContent style="display: none;">
    @if (displayTooltipContent) {
      <div class="tooltip-content">
        @if (!hidePerson) {
          @if (displayConsultImage) {
            <div class="row align-items-center" data-cy="user-consult">
              <div class="col-3">
                <div class="consult-image-container">
                  <img
                    width="68px"
                    height="68px"
                    [src]="clientConsultService.clientConsultImage.value"
                    data-cy="client-consult-photo"
                    alt="consultant-photo"
                    >
                </div>
              </div>
              <div class="col-9">
                <div class="explain-tooltip-name">
                  {{ clientConsultService.clientConsult.value!.name }}
                  {{ clientConsultService.clientConsult.value!.surname }}
                </div>
                <div class="explain-tooltip-short-desc">
                  {{ 'tooltip.explain.shortDesc' | translate }}
                </div>
              </div>
            </div>
          } @else {
            <div class="row align-items-center" data-cy="default-consult">
              <div class="col-3">
                <img
                  class="explain-image"
                  src="/assets/images/foto_{{explainPerson}}_BWM.png"
                  data-cy="consult-image-photo"
                  [alt]="explainPerson + '_photo'"
                  >
              </div>
              <div class="col-9">
                <div class="explain-tooltip-name">
                  {{ 'tooltip.explain.' + explainPerson | translate }}
                </div>
                <div class="explain-tooltip-short-desc">
                  {{ 'tooltip.explain.shortDesc' | translate }}
                </div>
              </div>
            </div>
          }
        }
        <div>
          <div class="explain-tooltip-content explain-tooltip-text">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    }
  </div>
}